(function () {
  'use strict';

  function setOpen(open) {
    var nav = document.querySelector('[data-velvety-mobile-nav]');
    var toggle = document.querySelector('[data-velvety-header-menu-toggle]');
    if (!nav) return;
    if (open) {
      nav.removeAttribute('hidden');
      requestAnimationFrame(function () { nav.classList.add('is-open'); });
      document.body.classList.add('velvety-mobile-nav-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    } else {
      nav.classList.remove('is-open');
      document.body.classList.remove('velvety-mobile-nav-open');
      setTimeout(function () { nav.setAttribute('hidden', 'hidden'); }, 300);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function init() {
    var toggle = document.querySelector('[data-velvety-header-menu-toggle]');
    var closers = document.querySelectorAll('[data-velvety-mobile-nav-close]');
    var searchToggle = document.querySelector('[data-velvety-header-search-toggle]');
    var inlineSearch = document.querySelector('.velvety-search');

    if (toggle) toggle.addEventListener('click', function () { setOpen(true); });
    closers.forEach(function (c) {
      c.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setOpen(false);
        if (inlineSearch) inlineSearch.classList.remove('is-open');
      }
    });

    /* Mobile-only inline search toggle (above the hamburger menu). On phones we hide
       the inline search form by default; tapping the magnifier reveals it as an
       overlay strip pinned below the header. */
    if (searchToggle && inlineSearch) {
      searchToggle.addEventListener('click', function () {
        var open = inlineSearch.classList.toggle('is-open');
        if (open) {
          var input = inlineSearch.querySelector('input[type="search"]');
          if (input) setTimeout(function () { input.focus(); }, 30);
        }
      });
      document.addEventListener('click', function (e) {
        if (!inlineSearch.classList.contains('is-open')) return;
        if (inlineSearch.contains(e.target) || searchToggle.contains(e.target)) return;
        inlineSearch.classList.remove('is-open');
      });
    }

    /* Account dropdown — click the avatar to toggle the menu (wraps the
       avatar + dropdown into one menu); close on outside click or Escape. */
    var accountGroup = document.querySelector('[data-velvety-account]');
    var accountToggle = accountGroup ? accountGroup.querySelector('[data-velvety-account-toggle]') : null;
    if (accountGroup && accountToggle) {
      var closeAccount = function () {
        accountGroup.classList.remove('is-open');
        accountToggle.setAttribute('aria-expanded', 'false');
      };
      accountToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = accountGroup.classList.toggle('is-open');
        accountToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!accountGroup.classList.contains('is-open')) return;
        if (accountGroup.contains(e.target)) return;
        closeAccount();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAccount();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Robust body scroll-lock for mobile overlays (nav drawer,
   filter drawer, sort sheet). They all toggle the shared
   `velvety-mobile-nav-open` body class; plain `overflow:hidden`
   leaks touch-scroll on iOS (background scrolls behind the
   overlay), so we position:fixed the body and restore the scroll
   position on close. One observer covers every overlay regardless
   of which script opened it.
   ============================================================ */
(function () {
  var LOCK_CLASS = 'velvety-mobile-nav-open';
  var locked = false;
  var savedY = 0;
  function lock() {
    if (locked) return;
    locked = true;
    savedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -savedY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    window.scrollTo(0, savedY);
  }
  function sync() {
    if (document.body.classList.contains(LOCK_CLASS)) lock();
    else unlock();
  }
  new MutationObserver(sync).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
  sync();
})();

/* ============================================================
   Sticky header shows only the menu (nav) bar. The sticky section
   is offset up by exactly the top row's height (country/currency +
   logo + promo), so on scroll that row slides off the top and the
   nav row pins at viewport top — no display:none, no layout jump.
   Measured here because the top row height varies (logo clamp, rem
   padding); on mobile the top row is hidden so height = 0 -> offset 0.
   ============================================================ */
(function () {
  var section = document.querySelector('.velvety-header-section');
  var header = document.querySelector('[data-velvety-header]');
  var topRow = document.querySelector('[data-velvety-header] .velvety-header__row--top');
  var navRow = document.querySelector('[data-velvety-header] .velvety-header__row--bottom');
  if (!section || !header || !topRow || !navRow) return;

  function setOffset() {
    var h = topRow.offsetHeight; // 0 when the top row is hidden (mobile)
    section.style.setProperty('--velvety-header-sticky-top', '-' + h + 'px');
  }

  // The header is "stuck" once the nav row has pinned to the viewport top
  // (i.e. the top row has fully scrolled off). Toggling this class crossfades
  // the search box out and the brand logo in (see CSS).
  function onScroll() {
    var stuck = navRow.getBoundingClientRect().top <= 1;
    header.classList.toggle('velvety-header--stuck', stuck);
  }

  setOffset();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { setOffset(); onScroll(); }, { passive: true });
  window.addEventListener('load', function () { setOffset(); onScroll(); }); // fonts/images can resize the row
})();
